import { Building2, Globe, Thermometer, Video, type LucideIcon } from 'lucide-react';

export interface NavLink {
  label: string;
  to: string;
  end?: boolean;
}

export interface NavSection {
  key: string;
  label: string;
  icon: LucideIcon;
  monitor: NavLink[];
  configure: NavLink[];
}

/** Meraki-style sections for one tenant ("network") dashboard. */
export function tenantNav(base: string, opts: { canConfigure: boolean }): NavSection[] {
  const c = opts.canConfigure;
  return [
    {
      key: 'network',
      label: 'Network-wide',
      icon: Globe,
      monitor: [
        { label: 'Overview', to: `${base}/overview` },
        { label: 'Sites', to: `${base}/sites` },
        { label: 'Event log', to: `${base}/events` },
      ],
      configure: [
        { label: 'General', to: `${base}/settings` },
        ...(c ? [{ label: 'Administrators', to: `${base}/administrators` }] : []),
        { label: 'Alert profiles', to: `${base}/alert-profiles` },
      ],
    },
    {
      key: 'sensors',
      label: 'Sensors',
      icon: Thermometer,
      monitor: [
        { label: 'Sensors', to: `${base}/sensors` },
        { label: 'Alerts', to: `${base}/alerts` },
      ],
      configure: [
        { label: 'Alert profiles', to: `${base}/alert-profiles` },
        { label: 'Integrations', to: `${base}/integrations` },
      ],
    },
    {
      key: 'cameras',
      label: 'Cameras',
      icon: Video,
      monitor: [
        { label: 'Cameras', to: `${base}/cameras` },
        { label: 'Licence plates', to: `${base}/plates` },
      ],
      configure: [{ label: 'Integrations', to: `${base}/integrations` }],
    },
  ];
}

/** The MSP ("organization") section, only visible to MSP administrators. */
export function mspNav(): NavSection {
  return {
    key: 'organization',
    label: 'Organization',
    icon: Building2,
    monitor: [{ label: 'MSP portal', to: '/msp', end: true }],
    configure: [{ label: 'Create tenant', to: '/msp/tenants/new' }],
  };
}

export function activeSectionKey(sections: NavSection[], pathname: string): string | undefined {
  let best: { key: string; len: number } | undefined;
  for (const s of sections) {
    for (const l of [...s.monitor, ...s.configure]) {
      const match = l.end ? pathname === l.to : pathname === l.to || pathname.startsWith(`${l.to}/`);
      if (match && (!best || l.to.length > best.len)) best = { key: s.key, len: l.to.length };
    }
  }
  return best?.key;
}
